/** Source role check shared by requirement and typed connectivity extraction. */
export function sourceSupportsFiberBuildDistanceFt(body: string, distanceFt: number): boolean {
  if (!Number.isFinite(distanceFt) || distanceFt < 0) return false;
  const clauses = body.split(/[\r\n;]+|(?<=[.!?])\s+/);
  return clauses.some(clause => {
    const line = clause.replace(/[*_`]/g, ' ');
    const role = /\b(?:build\s+(?:distance|length)|construction\s+(?:route|length|distance)|trench(?:ing)?\s+(?:length|distance)|(?:route|extension)\s+to\s+(?:the\s+)?handoff)\b/i.exec(line);
    if (!role || /\b(?:nearest|proximity|straight[- ]line|as\s+the\s+crow)\b/i.test(line)) return false;
    // Bind the first quantity after this construction label. Another
    // quantity in the same sentence (for example the full drawn route)
    // must not inherit the handoff-build role.
    const suffix = line.slice(role.index + role[0].length);
    const quantity = /(\d[\d,]*(?:\.\d+)?)\s*(feet|foot|ft|miles?|mi)\b/i.exec(suffix);
    if (!quantity || quantity.index > 160
      || /\b(?:full|entire|drawn|mapped)\s+(?:fiber\s+)?route\b/i.test(suffix.slice(0, quantity.index))) return false;
    const amount = Number(quantity[1]!.replace(/,/g, '')) * (/^(?:mi|mile|miles)$/i.test(quantity[2]!) ? 5280 : 1);
    return Math.abs(amount - distanceFt) <= 0.01;
  });
}
